export const MUSIC_CONSTANTS = {
    pulsesPerQuarterNote: 480,
} as const;